
import { useCallback, useState, createContext } from 'react';
import './Styles/App.css';

import {BrowserRouter as Router, createBrowserRouter, RouterProvider, Routes, Route, Redirect, Navigate} from 'react-router-dom';



//Distributor page root
import DistributorRoot from './routes/distributorRoot';

import Dashboard from './routes/distributorRoots/Dashboard';
import Artists from './routes/distributorRoots/Artists';
import Playlists from './routes/distributorRoots/Playlists';
import Settings from './routes/distributorRoots/Settings';
import Upload from './routes/distributorRoots/Upload';
import Playlist from './routes/distributorRoots/Playlist';
import Artist from './routes/distributorRoots/Artist';
import Albums from './routes/distributorRoots/Albums';
import Album from './routes/distributorRoots/Album';
import Podcasters from './routes/distributorRoots/Podcasters';
import UploadPodcasts from './routes/distributorRoots/UploadPodcasts';
import Releases from './routes/distributorRoots/Releases';
import Release from './routes/distributorRoots/Release';
import MergeSingles from './routes/distributorRoots/MergeSingles';
import SalesReport from './routes/distributorRoots/SalesReport';
import Payouts from './routes/distributorRoots/Payouts';
import RoyaltyHistory from './routes/distributorRoots/RoyaltyHistory';

import Podcaster from './routes/distributorRoots/Podcaster';
//Admin
import ProfileReports from "./routes/adminRoots/ProfileReports";
import MusicReports from "./routes/adminRoots/MusicReports";
import GenreReview from "./routes/adminRoots/GenreReview";
import PostsReports from "./routes/adminRoots/PostsReport";
import Admin from "./routes/adminRoots/Admin";
import Ads from "./routes/adminRoots/Ads";
import AdsStats from "./routes/adminRoots/AdsStats";
import AdRevenue from "./routes/adminRoots/AdRevenue";
import PushNotifications from "./routes/adminRoots/PushNotifications";
import Distributors from "./routes/adminRoots/Distributors";
import ListBugReports from "./Pages/BugReports/List";
import UpdateBugReports from "./Pages/BugReports/Update";
import ListMusics from './routes/adminRoots/ListMusics';
import AdminReleases from './routes/adminRoots/AdminReleases';
import Genres from './routes/adminRoots/Genres';
import DashboardOperations from './routes/adminRoots/DashboardOperations';
import DashboardStreams from './routes/adminRoots/DashboardStreams';
import AdminUsers from './routes/adminRoots/AdminUsers';
import NewAlbum from './routes/adminRoots/NewAlbum';
//Login

import Home from './routes/loginRoots/Home';
import DistributorLogin from './routes/distributorRoots/DistributorLogin';
import AdminLogin from './routes/adminRoots/AdminLogin';
import Lyrics from './routes/adminRoots/Lyrics';
import AdminArtists from './routes/adminRoots/Artists';
import PlatformUsers from './routes/adminRoots/Users';
import PromoCodes from './routes/adminRoots/PromoCodes';
import CampaignLeads from './routes/adminRoots/CampaignLeads';
import ArtistPayouts from './routes/adminRoots/ArtistPayouts';
import CuratorApplications from './routes/adminRoots/CuratorApplications';
import PlaylistReview from './routes/adminRoots/PlaylistReview';
import WeeklyPlaylists from './routes/adminRoots/WeeklyPlaylists';
import StoreFeatured from './routes/adminRoots/StoreFeatured';
import AdminRadios from './routes/adminRoots/Radios';
import RadioStats from './routes/adminRoots/RadioStats';
import StreamIntegrity from './routes/adminRoots/StreamIntegrity';
import StreamHealth from './routes/adminRoots/StreamHealth';
import AdminSettings from './routes/adminRoots/AdminSettings';
import Royalties from './routes/adminRoots/Royalties';
import FeaturedArtists from './routes/adminRoots/FeaturedArtists';
import HelpCenter from './routes/adminRoots/HelpCenter';

// Artist
import UploadArtistMusic from './routes/artistRoutes/UploadArtistMusic';
import ArtistLanding from './routes/artistRoutes/ArtistLanding';
import ArtistHome from './routes/artistRoutes/ArtistHome';
//main app component
function App() {
  const [user, setUser] = useState(null);
   
  const distributor_rooter = createBrowserRouter([
    {
      path:'/',
      element: <DistributorRoot/>,
      errorElement:<DistributorRoot/>,
      children:[
        { 
          path: '/',
          element: <Dashboard/>
        },
        { 
          path: '/dashboard',
          element: <Dashboard/>
        },
        { 
          path: '/settings',
          element: <Settings/>
        },
        { 
          path: '/artists',
          element: <Artists/>
        },{ 
          path: '/playlists',
          element: <Playlists/>
        },
        { 
          path: '/albums',
          element: <Albums/>
        },
        { 
          path: '/album/:playlist_id',
          element: <Album/>
        },
        { 
          path: '/upload',
          element: <Upload/>
        },
        { 
          path: '/podcasts',
          element: <UploadPodcasts/>
        },
        { 
          path: '/podcasters',
          element: <Podcasters/>
        },
        { 
          path: '/podcaster/:artist_id',
          element: <Podcaster/>
        },
        { 
          path: '/playlist/:playlist_id',
          element: <Playlist/>
        },
        {
          path: '/artist/:artist_id',
          element: <Artist/>
        },
        {
          path: '/releases',
          element: <Releases/>
        },
        {
          path: '/release/:release_id',
          element: <Release/>
        },
        {
          path: '/merge-singles',
          element: <MergeSingles/>
        },
        {
          path: '/sales-report',
          element: <SalesReport/>
        },
        {
          path: '/royalties',
          element: <RoyaltyHistory/>
        },
        {
          path: '/payouts',
          element: <Payouts/>
        }
      ]
    }
  ]);
  const admin_rooter = createBrowserRouter([
    {
      path:'/',
      element: <Admin/>,
      errorElement:<Admin/>,
      children:[
        { 
         
          path: '/streams',
          element: <DashboardStreams/>
        },
        {
          path: '/album',
          element: <NewAlbum/>
        },
        { 
         
          path: '/posts',
          element: <PostsReports/>
        },
        { 
          path: '/genres',
          element: <Genres/>
        },
        { 
          path: '/lyrics',
          element: <Lyrics/>
        },
        { 
          path: '/profiles',
          element: <ProfileReports/>
        },
        {
          path: '/music-reports',
          element: <MusicReports/>
        },
        {
          path: '/genre-review',
          element: <GenreReview/>
        },
        { 
          path: '/distributors',
          element: <Distributors/>
        },
        {
          path: '/ads',
          element: <Ads/>
        },
        {
          path: '/ads-stats',
          element: <AdsStats/>
        },
        {
          path: '/ad-revenue',
          element: <AdRevenue/>
        },
        {
          path: '/push',
          element: <PushNotifications/>
        },
        {
        
          path:'/',
          element: <DashboardOperations/>
        },
        {
        
          path:'/admin',
          element: <DashboardOperations/>
        },
        {
        
          path:'/admins',
          element: <AdminUsers/>
        },
        { 
          path: '/list-musics',
          element: <ListMusics/>
        },
        {
          path: '/releases-list',
          element: <AdminReleases/>
        },
        { 
          path: '/bug-reports',
          element: <ListBugReports />
        },
        {
          path: '/bug-reports/:id',
          element: <UpdateBugReports />
        },
        {
          path: '/artists-list',
          element: <AdminArtists />
        },
        {
          path: '/users-list',
          element: <PlatformUsers />
        },
        {
          path: '/promo-codes',
          element: <PromoCodes />
        },
        {
          path: '/campaign-leads',
          element: <CampaignLeads />
        },
        {
          path: '/curators',
          element: <CuratorApplications />
        },
        {
          path: '/playlist-review',
          element: <PlaylistReview />
        },
        {
          path: '/weekly-playlists',
          element: <WeeklyPlaylists />
        },
        {
          path: '/store-featured',
          element: <StoreFeatured />
        },
        {
          path: '/admin-radios',
          element: <AdminRadios />
        },
        {
          path: '/radio-stats',
          element: <RadioStats />
        },
        {
          path: '/stream-integrity',
          element: <StreamIntegrity />
        },
        {
          path: '/stream-health',
          element: <StreamHealth />
        },
        {
          path: '/admin-settings',
          element: <AdminSettings />
        },
        {
          path: '/royalties',
          element: <Royalties />
        },
        {
          path: '/artist-payouts',
          element: <ArtistPayouts />
        },
        {
          path: '/sales-report',
          element: <SalesReport admin />
        },
        {
          path: '/featured-artists',
          element: <FeaturedArtists />
        },
        {
          path: '/help-center',
          element: <HelpCenter />
        },
        {
          path: '/release/:release_id',
          element: <Release/>
        },
      ]
    }
  ]);

  const artist_router = createBrowserRouter([
    {
      path:'/',
      element: <ArtistLanding/>,
      errorElement:<Home/>,
      children:[
        {
          index:true,
          path: '/',  
          element: <ArtistHome/>,
        },
        { 
          path: '/upload',  
          element: <UploadArtistMusic/>
        },
        { 
          path: '/home',  
          element: <ArtistHome/>,
        },
      ]},
      
  ]);
  const login_rooter = createBrowserRouter([
    {
      path:'/',
      element: <Home/>,
      errorElement:<Home/>,
      children:[
        { 
          path: '/home',  
          element: <Home/>
        },
        
      ]},
      { 
        path: '/distributor',
        element: <DistributorLogin/>
      },
      { 
        path: '/uploadArtistMusic',  
        element: <UploadArtistMusic/>
      },
      { 
        path: '/admin',
        element: <AdminLogin/>
      },
  ]);

  const content = useCallback(()=>{
    const token = localStorage.getItem('user');
    const type  = localStorage.getItem('type');
    
    if(token !==null && token.length > 0){
      if(type == 'distributor'){
        return (<RouterProvider router={distributor_rooter}/>);
      }else if(type=="admin"){
        return (
                <RouterProvider router={admin_rooter}/>
              );
      }else if(type=="artist"){
        return (<RouterProvider router={artist_router}/>);
      }else{
        return (<RouterProvider router={login_rooter}/>);
      }
    }else{
      return (<RouterProvider router={login_rooter}/>);
      //return (<RouterProvider router={artist_router}/>);
    }
  

  },[distributor_rooter, admin_rooter, login_rooter]);
  return (
 
      <div className="App">
          
          
              {content()}
         
      </div> 
  );
}

export default App;
